export default __webpack_public_path__ + "static/media/Iphone.c82c194b.png";